import { useEffect, useRef } from 'react';
import { useTracking } from '../context/TrackingContext';

interface UseTrackingUrlOptions {
    baseUrl: string;
    tag: string;
    passthru1?: string;
    passthru2?: string;
    id?: string;
    productId?: string;
}

export function useTrackingUrl(options: UseTrackingUrlOptions) {
    const { trackingData } = useTracking();
    const linkRef = useRef<HTMLAnchorElement>(null);
    
    const {
        baseUrl = 'https://rabbits.webcam/',
        tag,
        passthru1 = '',
        passthru2 = '',
        id = '2333',
        productId = '7311'
    } = options;

    // Generate the tracking URL
    const generateUrl = () => `${baseUrl}?id=${id}&product_id=${productId}&tag=${tag}&passthru1=${passthru1}&passthru2=${passthru2}&exid=${trackingData.exid}&tfid=${trackingData.tfid}`;
    
    const trackingUrl = generateUrl();

    // Update the actual DOM href when tracking data changes
    useEffect(() => {
        if (linkRef.current && trackingData.exid && trackingData.tfid) {
            linkRef.current.href = generateUrl();
        }
    }, [trackingData.exid, trackingData.tfid, baseUrl, id, productId, tag, passthru1, passthru2]);

    return {
        trackingUrl,
        linkRef,
    };
}
